import React from "react";

const EvacuationIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M9.48305 0.0270683L16.6021 2.00712C16.8427 2.07398 16.9991 2.28843 16.9991 2.52103H17V17.8148C17 18.0778 16.8054 18.2957 16.5506 18.3409L9.43303 19.986C9.13898 20.0528 8.84606 19.8739 8.77767 19.5867C8.76781 19.5459 8.76346 19.5059 8.76346 19.4659H8.76251V18.7307L0.936918 18.7317C0.419103 18.7317 0 18.322 0 17.8159V13.2939C0 12.7896 0.420998 12.3782 0.936918 12.3782C1.45284 12.3782 1.87478 12.7896 1.87478 13.2939V16.8992H8.76156L8.76061 3.4379H1.87403V7.08282C1.87403 7.58709 1.45303 7.99859 0.937108 7.99859C0.421187 7.99859 0 7.58709 0 7.08263V2.52177C0 2.01564 0.419292 1.606 0.936918 1.606H8.7608V0.53486C8.7608 0.239667 9.00597 3.05176e-05 9.30799 3.05176e-05C9.36918 3.05176e-05 9.42792 0.00966041 9.48286 0.0278091V0.0270683H9.48305ZM0.368704 11.364L4.73707 11.3629V12.2924C4.73707 12.5915 5.09934 12.7746 5.35379 12.5587L7.955 10.4588C8.13935 10.3096 8.12741 10.0403 7.94609 9.89753L5.34205 7.76895C5.10256 7.57339 4.73783 7.7408 4.73783 8.04525L4.73726 9.00102H0.368894C0.165974 9.00102 0.00189468 9.1614 0.00189468 9.35973L0.000189468 11.0044C0.000189468 11.2035 0.165405 11.365 0.369083 11.365V11.3644L0.368704 11.364Z"
				fill="white"
			/>
		</svg>
	);
};

export default EvacuationIcon;
